import { Injectable } from '@angular/core';
import { DocumentDirection } from '@phx-erp/shared';
import { BaseDataService } from '../../../data/services/base-data.service';
import { GET_LINE_ITEM_PRICE_HISTORY } from '../../../data/definitions/analytics.definition';
import { QueryResult } from '../../../data/query-result';

/** Mirrors {@link LineItemPriceHistoryInput} until codegen includes analytics types. */
export interface LineItemPriceHistoryQueryInput {
  productId: string;
  customerId?: string;
  itemsCount?: number;
  documentDirection?: DocumentDirection;
  documentTypes?: string[];
}

export interface LineItemPriceHistorySummaryRow {
  avgUnitPrice?: number | null;
  weightedAvgUnitPrice?: number | null;
  peakUnitPrice?: number | null;
  minUnitPrice?: number | null;
  totalQuantity?: number | null;
  transactionCount?: number | null;
  totalRevenue?: number | null;
  currentDelta?: number | null;
  currentDeltaPercent?: number | null;
  currency?: string | null;
}

export interface LineItemPriceHistoryEntryRow {
  date?: string | null;
  documentId?: string | null;
  documentIdentifier?: string | null;
  documentType?: string | null;
  documentStatus?: string | null;
  lineItemId?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  referenceListUnitPrice?: number | null;
  documentPriceListUnitPrice?: number | null;
  referenceListDelta?: number | null;
  referenceListDeltaPercent?: number | null;
  lineTotal?: number | null;
  calculatoryCosts?: number | null;
  discountPercentage?: number | null;
  discountPercentage2?: number | null;
  priceSource?: string | null;
  delta?: number | null;
  deltaPercent?: number | null;
  currency?: string | null;
}

export interface LineItemPriceHistoryApplyPayload {
  unitPrice: number;
  discountPercentage?: number | null;
  discountPercentage2?: number | null;
}

export interface LineItemPriceHistoryData {
  summary: LineItemPriceHistorySummaryRow;
  items: LineItemPriceHistoryEntryRow[];
}

export interface GetLineItemPriceHistoryQuery {
  lineItemPriceHistory: LineItemPriceHistoryData;
}

export interface GetLineItemPriceHistoryQueryVariables {
  input: LineItemPriceHistoryQueryInput;
}

@Injectable({
  providedIn: 'root',
})
export class LineItemAnalyticsService {
  constructor(private readonly baseDataService: BaseDataService) {}

  getLineItemPriceHistory(
    input: LineItemPriceHistoryQueryInput,
  ): QueryResult<GetLineItemPriceHistoryQuery, GetLineItemPriceHistoryQueryVariables> {
    return this.baseDataService.query<GetLineItemPriceHistoryQuery, GetLineItemPriceHistoryQueryVariables>(
      GET_LINE_ITEM_PRICE_HISTORY,
      { input },
    );
  }
}
